import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f7616f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["loading", "onClick"]
const _hoisted_2 = ["loading"]
const _hoisted_3 = { class: "trigger-icon" }
const _hoisted_4 = ["loading", "onClick"]
const _hoisted_5 = ["loading"]
const _hoisted_6 = {
  key: 1,
  style: {"width":"12px"}
}
const _hoisted_7 = { class: "flow-model-title" }
const _hoisted_8 = { class: "flow-model-subtitle" }
const _hoisted_9 = {
  key: 0,
  class: "flow-model__subtitle mt14"
}
const _hoisted_10 = {
  key: 1,
  class: "flow-model__subtitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeBtnArr, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!item.componentName)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (!item.popconfirm)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "javascript:void(0);",
                        size: "small",
                        type: "link",
                        style: _normalizeStyle(item.style),
                        loading: item.loading,
                        onClick: _withModifiers(($event: any) => (item.fn(_ctx.record)), ["stop"])
                      }, _toDisplayString(item.label), 13, _hoisted_1))
                    : (_openBlock(), _createBlock(_component_a_popconfirm, {
                        key: 1,
                        title: item.popconfirm,
                        placement: "bottomRight",
                        onConfirm: ($event: any) => (item.fn(_ctx.record)),
                        class: "append-to-table"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", {
                            href: "javascript:void(0);",
                            size: "small",
                            type: "link",
                            style: _normalizeStyle(item.style),
                            loading: item.loading
                          }, _toDisplayString(item.label), 13, _hoisted_2)
                        ]),
                        _: 2
                      }, 1032, ["title", "onConfirm"]))
                ], 64))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(item.componentName), _mergeProps({ key: 1 }, item.config(_ctx.record), { onRefresh: _ctx.refresh }), null, 16, ["onRefresh"]))
          ], 64))
        }), 256)),
        (_ctx.moreBtnArr.length > 0)
          ? (_openBlock(), _createBlock(_component_a_dropdown, {
              key: 0,
              placement: 'bottomRight',
              getPopupContainer: _ctx.getContainer
            }, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, { class: "btn-menu" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moreBtnArr, (item) => {
                      return (_openBlock(), _createBlock(_component_a_menu_item, null, {
                        default: _withCtx(() => [
                          (!item.componentName)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (!item.popconfirm)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: "javascript:void(0);",
                                      size: "small",
                                      type: "link",
                                      style: _normalizeStyle(item.style),
                                      loading: item.loading,
                                      onClick: _withModifiers(($event: any) => (item.fn(_ctx.record)), ["stop"])
                                    }, _toDisplayString(item.label), 13, _hoisted_4))
                                  : (_openBlock(), _createBlock(_component_a_popconfirm, {
                                      key: 1,
                                      title: item.popconfirm,
                                      placement: "bottomRight",
                                      onConfirm: ($event: any) => (item.fn(_ctx.record)),
                                      class: "append-to-table"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          href: "javascript:void(0);",
                                          size: "small",
                                          type: "link",
                                          style: _normalizeStyle(item.style),
                                          loading: item.loading
                                        }, _toDisplayString(item.label), 13, _hoisted_5)
                                      ]),
                                      _: 2
                                    }, 1032, ["title", "onConfirm"]))
                              ], 64))
                            : (_openBlock(), _createBlock(_resolveDynamicComponent(item.componentName), _mergeProps({ key: 1 }, item.config(_ctx.record), { onRefresh: _ctx.refresh }), null, 16, ["onRefresh"]))
                        ]),
                        _: 2
                      }, 1024))
                    }), 256))
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_svg_icon, {
                    "icon-class": "morebtn",
                    size: "12"
                  })
                ])
              ]),
              _: 1
            }, 8, ["getPopupContainer"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6))
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      confirmLoading: _ctx.loading,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      centered: true,
      onOk: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleOk(_ctx.currentAction)))
    }, {
      title: _withCtx(() => [
        _createElementVNode("h4", _hoisted_7, _toDisplayString(_ctx.modelMap.get(_ctx.currentAction)?.title), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.modelMap.get(_ctx.currentAction)?.subtitle), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.currentAction == 'delete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 当前审批状态：" + _toDisplayString(_ctx.record?.flowStatusName), 1))
          : _createCommentVNode("", true),
        (_ctx.currentAction == 'delete')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, "删除原因"))
          : _createCommentVNode("", true),
        _createVNode(_component_a_textarea, {
          "show-count": "",
          value: _ctx.approvalContent,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.approvalContent) = $event)),
          placeholder: '请输入' + _ctx.modelMap.get(_ctx.currentAction)?.title + '，最多200字',
          "auto-size": { minRows: 3 },
          maxlength: 200,
          allowClear: ""
        }, null, 8, ["value", "placeholder"])
      ]),
      _: 1
    }, 8, ["confirmLoading", "visible"])
  ], 64))
}